module.exports = __webpack_public_path__ + "media/images/expert__benedikt-doll-b06d9814d981fb8f394fd03c9c9aac18.png";